<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>insights</mat-icon> Reports
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <mat-form-field appearance="fill">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" [(ngModel)]="dateStart" [disabled]="reportingType === reportingTypeObjects.REEF_CERTIFICATE_REPORT">
          <input matEndDate placeholder="End date" [(ngModel)]="dateEnd" [disabled]="reportingType === reportingTypeObjects.REEF_CERTIFICATE_REPORT">
        </mat-date-range-input>
        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      &nbsp;
      <mat-form-field appearance="fill">
        <mat-icon matPrefix>account_circle</mat-icon>
        <mat-label>Filter to user</mat-label>
        <mat-select [(ngModel)]="filterUser" [disabled] = "reportingType === reportingTypeObjects.REEF_CERTIFICATE_REPORT">
          <mat-select-trigger>
            {{ filterUser ? filterUser.name : '' }}
          </mat-select-trigger>
          <mat-option [value]="null">
            None
          </mat-option>
          <mat-option [value]="user" *ngFor="let user of dataService.knownUsers | async">
            {{ user.name }} ({{user.email}})
          </mat-option>
        </mat-select>
      </mat-form-field>
      &nbsp;
      <mat-form-field appearance="fill"
                      *ngIf="
                      reportingType &&
                      reportingType !== reportingTypeObjects.CONTACT_EVENTS &&
                      reportingType !== reportingTypeObjects.INTERACTIONS_PER_USER &&
                      reportingType !== reportingTypeObjects.MEETING_WITH_OTHERS &&
                      reportingType !== reportingTypeObjects.ASSISTANCE_REPORT &&
                      reportingType !== reportingTypeObjects.PRACTICE_CHANGE_REPORT &&
                      reportingType !== reportingTypeObjects.REEF_CERTIFICATE_REPORT
                      "

      >
        <mat-icon matPrefix>filter_list</mat-icon>
        <mat-label>Filter to type</mat-label>
        <mat-select [(ngModel)]="filterCategory">
          <mat-select-trigger *ngIf="filterCategory">
            {{ filterCategory.name }}
          </mat-select-trigger>
          <mat-option [value]="null">
            None
          </mat-option>
          <mat-option [value]="cat" *ngFor="let cat of dataService.categories | async" [style.color]="invertColor(cat.color)" [style.background-color]="cat.color">
            <mat-icon>{{ cat.icon }}</mat-icon>&nbsp;&nbsp;{{ cat.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="reportingType === reportingTypeObjects.ASSISTANCE_REPORT">
        <mat-icon matPrefix>filter_list</mat-icon>
        <mat-label>Filter to type</mat-label>
        <mat-select [(ngModel)]="filterAssistanceType">
          <mat-select-trigger *ngIf="filterAssistanceType">
            {{ filterAssistanceType.name }}
          </mat-select-trigger>
          <mat-option [value]="null">
            None
          </mat-option>
          <mat-option [value]="cat" *ngFor="let cat of dataService.assistanceProvidedTypes | async" [style.color]="invertColor((cat.category | resolveCategory).color)" [style.background-color]="(cat.category | resolveCategory).color">
            <mat-icon>{{(cat.category | resolveCategory).icon}}</mat-icon>&nbsp;&nbsp;{{cat.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="reportingType === reportingTypeObjects.PRACTICE_CHANGE_REPORT">
        <mat-icon matPrefix>filter_list</mat-icon>
        <mat-label>Filter to activity</mat-label>
        <mat-select [(ngModel)]="filterPracticeChangeActivity">
          <mat-select-trigger *ngIf="filterPracticeChangeActivity">
            {{ filterPracticeChangeActivity.name }}
          </mat-select-trigger>
          <mat-option [value]="null">
            None
          </mat-option>
          <mat-option [value]="activity" *ngFor="let activity of dataService.practiceChangeActivities | async" [style.color]="invertColor((activity.category | resolveCategory).color)" [style.background-color]="(activity.category | resolveCategory).color">
            <mat-icon>{{(activity.category | resolveCategory).icon}}</mat-icon>&nbsp;&nbsp;{{activity.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      &nbsp;
      <mat-form-field appearance="fill">
        <mat-icon matPrefix>auto_awesome_motion</mat-icon>
        <mat-label>Result type</mat-label>
        <mat-select [(ngModel)]="reportingType" (ngModelChange)="chartOptions.series = []">
          <mat-option [value]="type" *ngFor="let type of reportingTypes">
            {{ reportingTypeHeaders[type][0] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br/>

      <button mat-raised-button (click)="loadReport()" color="primary" *ngIf="reportingType !== reportingTypeObjects.REEF_CERTIFICATE_REPORT">
        <mat-icon>refresh</mat-icon> Refresh
      </button>

    </mat-card-content>
</mat-card>

<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
  <mat-card-content *ngIf="reportLoading">
    <mat-spinner class="ml-auto mr-auto mt-5 mb-5 d-block"></mat-spinner>
    <br/><br/>
  </mat-card-content>
  <mat-card-header *ngIf="!reportLoading">
    <mat-card-title>
      <h1>
        {{ reportingTypeHeaders[reportingType][0] }}
      </h1>
    </mat-card-title>
    <mat-card-subtitle>
      {{ reportingTypeHeaders[reportingType][1] }}
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content *ngIf="!reportLoading">
    <highcharts-chart
      *ngIf="chartOptions && chartOptions.series.length && reportingType !== reportingTypeObjects.REEF_CERTIFICATE_REPORT"
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      style="width: 100%; height: 600px; display: block;"
    ></highcharts-chart>

    <br/>
    <button mat-raised-button (click)="downloadRaw()" color="primary" *ngIf="(reportResults && chartOptions.series.length) || reportingType === reportingTypeObjects.REEF_CERTIFICATE_REPORT">
      <mat-icon>download</mat-icon> Download raw
    </button>
    <!--&nbsp;&nbsp;
    <button mat-raised-button (click)="downloadReport()" color="primary" *ngIf="reportResults">
      <mat-icon>download</mat-icon> Download report
    </button>
    &nbsp;&nbsp;-->
  </mat-card-content>
</mat-card>
